// extracted by css-extract-rspack-plugin
export default {"cta":"tv7v9x7VeSU4KJWr","ctaNoBorder":"FRa7wv2ZyUuE8Uox","ctaNoPadding":"lN0KtnBRloJ0pRuG"};